import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  padding: 80px 5%;
  background: #ffffff;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 60px; /* Wider gap for cleaner look */

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const LeftSide = styled.div`
  flex: 1;
`;

const Title = styled.h2`
  font-family: 'Open Sans', sans-serif;
  font-size: 38px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 12px;
`;

const Subtitle = styled.h5`
  font-family: 'Open Sans', sans-serif;
  color: #fa6582;
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 25px;
`;

const Text = styled.p`
  font-family: 'Open Sans', sans-serif;
  color: #4a5568;
  font-size: 15px;
  line-height: 1.7;
  max-width: 400px;
  font-weight: 500;
`;

const Form = styled.form`
  flex: 1.5;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px; /* Tighter radius */
  padding: 35px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.06); /* Deeper shadow */
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 16px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 14px;
  color: #1a202c;
  font-family: 'Open Sans', sans-serif;
  background: #f8fafc;
  transition: border-color 0.3s, background 0.3s;
  
  &:focus {
    outline: none;
    border-color: #25aae3;
    background: #ffffff;
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 16px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 14px;
  color: #1a202c;
  font-family: 'Open Sans', sans-serif;
  background: #f8fafc;
  min-height: 140px;
  resize: vertical;
  margin-bottom: 20px;
  transition: border-color 0.3s, background 0.3s;

  &:focus {
    outline: none;
    border-color: #25aae3;
    background: #ffffff;
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const SubmitContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
`;

const MathText = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  color: #4a5568;
  font-weight: 600;
`;

const MathInput = styled.input`
  width: 60px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  text-align: center;
  font-weight: 700;
  font-size: 15px;
  
  &:focus {
    outline: none;
    border-color: #25aae3;
  }
`;

const SubmitBtn = styled.button`
  background: #25aae3;
  color: #fff;
  border: none;
  padding: 16px 30px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(37,170,227,0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background: #1c94c9;
    box-shadow: 0 6px 15px rgba(37,170,227,0.4);
    transform: translateY(-2px);
  }
`;

const Contact = () => {
  return (
    <SectionWrapper id="contact">
      <Container>
        <LeftSide>
          <Title>Contact</Title>
          <Subtitle>OUR PROMISE</Subtitle>
          <Text>
            Some days can be busy, however we always do our best to get back to our community members within 1-2 business days!
          </Text>
        </LeftSide>
        <Form>
          <FormRow>
            <Input type="text" placeholder="Name" />
            <Input type="email" placeholder="Email Address" />
          </FormRow>
          <TextArea placeholder="Message"></TextArea>
          <SubmitContainer>
            <MathText>12 + 5 =</MathText>
            <MathInput type="text" />
            <SubmitBtn>SEND MESSAGE</SubmitBtn>
          </SubmitContainer>
        </Form>
      </Container>
    </SectionWrapper>
  );
};

export default Contact;
